import { fetch } from '../services/fetch'
import { routes } from '../config'

export const login = (user, payload) => fetch.post(routes.login, user, payload)

export const register = (user, payload) => fetch.post(routes.register, user, payload)

export const resetPassword = (email, payload) => fetch.post(routes.resetPassword, email, payload)
